import { generatePath } from 'react-router';
import axiosInstance from '../api/index';
import { API_ROUTES } from '../consts';
import { buildOrder, buildRequestParamsByType, buildSelect } from '../utils/request';
import PaginationResponseDto from '../interfaces/paginationResponse.interface';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';
import request from './index';

export const getPrioritizedJobTitles = async (query: ApiQueryWithText): Promise<JobTitlesResponse>  => {
  const {
    text = '',
    select,
    page,
    limit,
    order = {},
  } = query;
  const { data } = await axiosInstance.get(API_ROUTES.PRIORITIZED_JOB_TITLES, {
    params: {
      text: text || '',
      select: buildSelect(select),
      page,
      limit,
      order: buildOrder(order || {}),
    },
  });

  return data;
};

export const getFieldsOfStudy = async (query: ApiQueryWithText): Promise<AutoCompleteResponse>  => {
  const {
    text = '',
    select,
    page,
    limit,
    order = {},
  } = query;
  const { data } = await axiosInstance.get(API_ROUTES.FIELD_OF_STUDY, {
    params: {
      text: text || '',
      select: buildSelect(select),
      page,
      limit,
      order: buildOrder(order || {}),
    },
  });

  return data;
};

export const getMatchFlows = async (
  positionId: string,
  accountId: string,
  query?: ApiQuery,
):Promise<PaginationResponseDto<MatchFlowResponse>> => {
  const url = generatePath(API_ROUTES.MATCH_FLOWS, { accountId, positionId });
  const { data } = await request.get(url, {
    params: {
      ...buildRequestParamsByType(query?.contains || {}, RequestQueryBuilderParamsEnum.contains),
      ...buildRequestParamsByType(query?.in || {}, RequestQueryBuilderParamsEnum.in),
      select: buildSelect(query?.select),
      limit: query?.limit,
      page: query?.page,
      order: buildOrder(query?.order || {}),
    },
  });

  return data;
};

export const getLastMatchFlow = async (
  accountId:string,
  positionId: string,
):Promise<MatchFlowResponse> => {
  const url = generatePath(API_ROUTES.MATCH_FLOW_LAST, { accountId, positionId });
  const { data } = await request.get(url);

  return data;
};

export const runEngineMatchFlow = async (
  accountId:string,
  positionId: string,
):Promise<MatchFlowResponse> => {
  const url = generatePath(API_ROUTES.MATCH_FLOWS, { accountId, positionId });

  const { data } = await request.post(url);

  return data;
};

export const cancelMatchFlow = async (
  accountId:string,
  positionId: string,
  matchFlowId: string,
):Promise<string> => {
  const url = generatePath(API_ROUTES.MATCH_FLOW_CANCEL, { accountId, positionId, matchFlowId });
  const { data } = await request.post(url);

  return data;
};
